import { Navigate, useLocation } from "react-router-dom";
import { useRole } from "../context/RoleContext";
import { CycleProvider } from "../context/CycleContext";
import AppLayout from "../layouts/AppLayout";
import Loader from "../components/common/Loader";
import Button from "../components/common/Button";

export default function ProtectedRoute() {
  const { isAuthenticated, profileLoading, profileError, logout } = useRole();
  const location = useLocation();

  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;
  if (profileLoading) return <Loader label="Loading your workspace" fullPage />;
  if (profileError) {
    return (
      <div className="fullpage-message">
        <h1>We couldn't load your profile</h1>
        <p>{profileError}</p>
        <Button onClick={logout}>Back to login</Button>
      </div>
    );
  }

  return (
    <CycleProvider>
      <AppLayout />
    </CycleProvider>
  );
}

export function PublicOnlyRoute({ children }) {
  const { isAuthenticated } = useRole();
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
}
